import * as React from 'react';

import { ButtonModel } from '@notino/react-styleguide';

import { AddToCartCoreComponent } from '@sharedComponents/AddToCartButton/AddToCartCoreComponentButton';
import { AddToCartButtonProvider } from '@sharedComponents/AddToCartButton/context';
import { MaxProductsInCartModal } from '@sharedComponents/AddToCartButton/MaxProductsInCartModal';
import { IAddToCartButtonProps } from '@sharedComponents/AddToCartButton/model';

import { ButtonWrapper } from './styled';

type CommonProps = Pick<
  IAddToCartButtonProps,
  | 'showAddToCartModal'
  | 'getModalAfterAddToCart'
  | 'buttonSize'
  | 'buttonWrapper'
  | 'buttonStyle'
  | 'count'
  | 'wrapable'
  | 'disableRedirect'
>;

type UpsellingAddToCartButtonProps = Omit<
  IAddToCartButtonProps,
  keyof CommonProps
>;

export const UpsellingAddToCartButton: React.FC<UpsellingAddToCartButtonProps> =
  React.memo((props) => {
    const commonProps: CommonProps = {
      showAddToCartModal: false,
      buttonWrapper: ButtonWrapper,
      buttonStyle: ButtonModel.Styles.secondary,
      buttonSize: ButtonModel.Sizes.xSmall,
      count: 1,
      disableRedirect: true,
      wrapable: true,
      getModalAfterAddToCart: (modalProps) =>
        modalProps.type === 'maxProductsInCart'
          ? [
              <MaxProductsInCartModal key="maxProductsInCart" />,
              {
                withFocusTrap: true,
              },
            ]
          : undefined,
    };

    return (
      <AddToCartButtonProvider {...props} {...commonProps}>
        <AddToCartCoreComponent {...props} {...commonProps} />
      </AddToCartButtonProvider>
    );
  });
